import { lazy } from 'react';

// ----------------------------------------------------------------------

const SettingPage = lazy(() => import('../pages/Setting.page'));

// ----------------------------------------------------------------------

const SettingRoutes = [
    {
        path: '/settings',
        element: <SettingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { SettingRoutes };
